import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TransferStock from "./TransferStock";
import instance from "../../Interceptor/api_instance";

const RowActions = ({ row, location, close, onUpdateStock }) => {
  const { t } = useTranslation();
  const [transferStockOpen, setTransferStockOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [currentQty, setCurrentQty] = useState(row?.quantity || 0);

  useEffect(() => {
    if (!row) return;
    let mounted = true;
    const fetchLogs = async () => {
      setLogsLoading(true);
      try {
        const res = await instance(`/safety/get-stock-logs?stock_id=${row.id}`);
        if (!mounted) return;
        setLogs(res.data || []);
      } catch (e) {
        // ignore for now
      } finally {
        if (mounted) setLogsLoading(false);
      }
    };
    fetchLogs();
    return () => {
      mounted = false;
    };
  }, [row]);

  // keep local currentQty in sync with prop row changes
  useEffect(() => {
    setCurrentQty(row?.quantity || 0);
  }, [row]);

  return (
    <div className="page-mask page-mask-animation">
      {transferStockOpen && (
        <TransferStock
          row={row}
          location={location}
          close={() => setTransferStockOpen(false)}
        />
      )}

      <div className="white-cont">
        <h2 className="global-h2 black">
          {row.part.sku} {row.part.name}
        </h2>
        <h4 className="global-h4">
          {t("yard-tables.table-columns.location")}: {location}
        </h4>
        <div className="flex-1 margin-bottom-24">
          <button
            className="purple-btn all-btn"
            onClick={() => setTransferStockOpen(true)}
          >
            {t("buttons.transfer-stock")}
          </button>
        </div>
        <div className="full-cont">
          <button className="cancel-btn all-btn" onClick={close}>
            {t("buttons.close")}
          </button>
        </div>
        <div className="full-cont margin-top-16">
          <h4 className="global-h4 gray">
            {t("forms.type.invoice.items") || "Recent Logs"}
          </h4>
          {logsLoading ? (
            <div>Loading...</div>
          ) : (
            <div>
              {logs.length === 0 && <div className="gray">No logs found.</div>}
              <ul className="log-list">
                {logs.map((l) => {
                  const canDelete = currentQty - l.quantity_changed >= 0;
                  const isAssigned =
                    l.ref_model === "MaintenanceReportPart" ||
                    l.change_type === "assigned";
                  const qtyText =
                    l.quantity_changed > 0
                      ? `+${l.quantity_changed}`
                      : String(l.quantity_changed);
                  const priceText = l.unit_price
                    ? new Intl.NumberFormat(undefined, {
                        style: "currency",
                        currency: "USD",
                      }).format(Number(l.unit_price))
                    : null;
                  const prevPriceText = l.previous_unit_price
                    ? new Intl.NumberFormat(undefined, {
                        style: "currency",
                        currency: "USD",
                      }).format(Number(l.previous_unit_price))
                    : null;
                  return (
                    <li key={l.id} className="log-item">
                      <div className="log-left">
                        <span className={`log-badge ${l.change_type || ""}`}>
                          {l.change_type}
                        </span>
                        <span
                          className={`log-qty ${
                            l.quantity_changed > 0 ? "plus" : "minus"
                          }`}
                        >
                          {qtyText}
                        </span>
                        <div className="log-info">
                          <div className="log-user small black">
                            {l.changed_by?.first_name || ""}{" "}
                            {l.changed_by?.last_name || ""}
                          </div>
                          <div className="small gray log-meta">
                            {new Date(l.created_at).toLocaleString()}{" "}
                            {l.note ? `— ${l.note}` : ""}
                          </div>
                          {priceText && (
                            <div className="small gray log-price">
                              Unit price: {priceText}
                              {prevPriceText ? ` (prev ${prevPriceText})` : ""}
                            </div>
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RowActions;
